<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      pageTitle: 'Location',
      breadcrumb: {
        name: new Promise((resolve) => {
          this.$sdk
            .dictionary_location
            .read(this.$route.params.locationId)
            .then((response) => {
              resolve(response.suburb)
            })
        }),
        route: { name: 'configuration-locations-location', params: { locationId: this.$route.params.locationId } }
      },
      sidebar: [
        {
          icon: ['fal', 'location'],
          route: { name: 'configuration-locations-location-detail', params: { locationId: this.$route.params.locationId } },
          name: 'Detail'
        }
      ]
    }
  }
}
</script>
